<div>
	<div class="text">
		<img src="assets/media/home/sunrise.svg" alt="welcome to Fyffes NA Portal">
		<h1>Welcome to Fyffes NA Portal</h1>
	</div>
	<video autoplay muted loop>
		<source src="assets/media/home/fyffes.mp4" type="video/mp4">
	</video>
</div>
